import { oz } from '@weft/utils';
import { BillingCycleInvoiceSchema } from './billing-cycle-invoice-schema';

export const GetBillingCycleInvoicesResponseSchema = oz.object({
  invoices: oz.array(BillingCycleInvoiceSchema),
}).openapi('GetBillingCycleInvoicesResponse');

export type GetBillingCycleInvoicesResponse = oz.infer<typeof GetBillingCycleInvoicesResponseSchema>;